import { Injectable } from '@angular/core';
import { Lines } from './lines.component';

@Injectable()
export class LinesService {
  linieAutobusowe: Array<Lines> = [];

  constructor() {
    let tmp: Lines = ({
      id: 1, przystanki: [227, 90, 624, 648, 21, 20, 570, 572, 569, 491, 490, 703, 183, 197, 198, 200, 204,
        282, 283, 279, 280, 278, 163, 164, 650, 32, 143, 144, 142],
      czas: ['13:20', '20:23']
    });
    this.linieAutobusowe.push(tmp);
    tmp = ({
      id: 2, przystanki: [233, 191, 199, 202, 182, 183, 703, 555, 554, 549, 543, 546, 542, 552, 547, 310, 309,
         311, 312, 313, 465, 464, 463],
         czas: ['13:20', '20:23']
    });
    this.linieAutobusowe.push(tmp);
    tmp = ({
      id: 3, przystanki: [135, 623, 625, 627, 206, 704, 167, 5, 40, 47, 41, 44, 567, 330, 331, 329, 328, 29, 342, 343, 419],
         czas: ['13:20', '20:23']
    });
    this.linieAutobusowe.push(tmp);
    tmp = ({
      id: 4, przystanki: [15, 510, 17, 528, 195, 549, 509, 14, 206, 490, 491, 568, 695, 25, 23, 565, 217, 659, 665, 663, 667, 661, 664],
         czas: ['13:20', '20:23']
    });
    this.linieAutobusowe.push(tmp);
    tmp = ({
      id: 5, przystanki: [233, 191, 201, 4, 1, 11, 588, 591, 599, 597, 600, 602, 598, 593, 594, 541, 539],
         czas: ['13:20', '20:23']
    });
    this.linieAutobusowe.push(tmp);
    tmp = ({
      id: 6, przystanki: [450, 494, 493, 235, 234, 164, 163, 278, 280, 279, 283, 282, 277, 281, 286, 206, 704,
                          121, 402, 401, 666, 322, 507, 427, 5, 2, 324, 699, 698],
         czas: ['13:20', '20:23']
    });
    this.linieAutobusowe.push(tmp);
    tmp = ({
      id: 7, przystanki: [219, 281, 121, 402, 401, 666, 218, 217, 597, 600, 602, 598, 593, 594, 596, 479, 136, 615, 616, 220, 222, 190,
                          187, 189, 188, 556, 113, 112, 111, 656, 651, 657, 655],
         czas: ['13:20', '20:23']
    });
    this.linieAutobusowe.push(tmp);
    tmp = ({
      id: 8, przystanki: [419, 343, 27, 184, 438, 186, 197, 198, 224, 225, 366, 703, 490, 491, 64, 63, 526, 668, 671, 677, 676,
                          674, 379, 378, 377, 376],
         czas: ['13:20', '20:23']
    });
    this.linieAutobusowe.push(tmp);
    tmp = ({
      id: 9, przystanki: [26, 184, 438, 186, 182, 183, 704, 424, 402, 401, 666, 322, 507, 427, 5, 2, 324, 323, 245, 244, 239, 248,
                          365, 361, 364, 649, 454, 130, 131, 127],
         czas: ['13:20', '20:23']
    });
    this.linieAutobusowe.push(tmp);
    tmp = ({
      id: 10, przystanki: [26, 184, 438, 186, 182, 183, 121, 9, 8, 487, 482, 489, 484, 488, 486, 483, 92, 91, 95, 96, 308, 305, 301, 306,
                            346, 347, 33, 117, 118, 345, 353, 352, 75, 77, 114, 119],
         czas: ['13:20', '20:23']
    });
    this.linieAutobusowe.push(tmp);
  }

}



// WEBPACK FOOTER //
// ./src/app/lines/lines.service.ts